import { Stack, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { spreadSx } from 'ui-kit/lib/utils/spreadSx';

export const Layout = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Stack sx={[styles.root, ...spreadSx(sx)]} className={'id-layout-root'}>
      <Stack sx={styles.body} className={'id-layout-body'}>
        {children}
      </Stack>
    </Stack>
  );
};
const styles = {
  root: {
    display: 'flex',
    backgroundColor: (t) => t.palette.bg.base.elevation1,
    flex: '1 1 auto',
    justifyContent: { xs: 'initial', sm: 'center' },
    alignItems: { xs: 'initial', sm: 'center' },
  },
  body: {
    backgroundColor: (t) => t.palette.bg.invert,
    flex: '1 1 auto',
    margin: { xs: 18, sm: '48px 0', lg: '48px 0' },
    maxWidth: { xs: 'initial', sm: 660, lg: 960 },
    maxHeight: { xs: 'initial', sm: 1054, lg: 'auto' },
    width: { xs: 'auto', sm: '100%' },
    padding: { xs: 24, sm: '48px 60px' },
    boxSizing: 'border-box',
  },
} satisfies Record<string, SxProps<Theme>>;
